export default __webpack_public_path__ + "static/media/Verify_Success.5290a53d.svg";